module.exports = __webpack_public_path__ + "img/Document.cf30d845.svg";